import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/logo-300.png'
import _imports_1 from '../../assets/images/profile-transparent.png'


const _hoisted_1 = { class: "bg-white shadow" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-2 sm:px-4 lg:px-8" }
const _hoisted_3 = { class: "flex justify-between h-16" }
const _hoisted_4 = { class: "flex px-2 lg:px-0" }
const _hoisted_5 = { class: "flex-shrink-0 flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-8 hidden sm:block",
  src: _imports_0,
  alt: "Inciteful Logo"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "block h-8 sm:hidden",
  src: _imports_1,
  alt: "Inciteful Logo"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden lg:flex\"><a href=\"https://help.inciteful.xyz\" class=\"ml-8 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out\"> Help </a><a href=\"https://twitter.com/Inciteful_xyz\" target=\"_blank\" class=\"ml-8 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 335 276\" fill=\"#3ba9ee\" class=\"w-5 h-5 inline mr-2\"><path d=\"m302 70a195 195 0 0 1 -299 175 142 142 0 0 0 97 -30 70 70 0 0 1 -58 -47 70 70 0 0 0 31 -2 70 70 0 0 1 -57 -66 70 70 0 0 0 28 5 70 70 0 0 1 -18 -90 195 195 0 0 0 141 72 67 67 0 0 1 116 -62 117 117 0 0 0 43 -17 65 65 0 0 1 -31 38 117 117 0 0 0 39 -11 65 65 0 0 1 -32 35\"></path></svg> Follow </a></div>", 1)
const _hoisted_9 = { class: "flex-1 flex items-center justify-center px-2 lg:ml-6 lg:justify-end" }
const _hoisted_10 = {
  key: 0,
  class: "hidden lg:flex px-2 lg:px-0"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Log In ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Register ")
const _hoisted_13 = { class: "inline-flex items-center justify-center h-8 w-8 rounded-full bg-violet-600 hover:bg-violet-500 focus:outline-none focus:border-violet-700 focus:ring-violet active:bg-violet-700 transition ease-in-out duration-150" }
const _hoisted_14 = { class: "text-sm font-medium leading-none text-white" }
const _hoisted_15 = { class: "flex flex-shrink items-center lg:hidden" }
const _hoisted_16 = { class: "pt-2 pb-3" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Register")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Log In")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Log Out")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Connector")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://help.inciteful.xyz",
  class: "mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
}, "Help", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://twitter.com/Inciteful_xyz",
  target: "_blank",
  class: "mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335 276",
    fill: "#3ba9ee",
    class: "w-5 h-5 inline mr-2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "m302 70a195 195 0 0 1 -299 175 142 142 0 0 0 97 -30 70 70 0 0 1 -58 -47 70 70 0 0 0 31 -2 70 70 0 0 1 -57 -66 70 70 0 0 0 28 5 70 70 0 0 1 -18 -90 195 195 0 0 0 141 72 67 67 0 0 1 116 -62 117 117 0 0 0 43 -17 65 65 0 0 1 -31 38 117 117 0 0 0 39 -11 65 65 0 0 1 -32 35" })
  ]),
  /*#__PURE__*/_createTextVNode(" Follow")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_graph_search = _resolveComponent("graph-search")!
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/",
              id: "logo"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_graph_search, {
            showImport: false,
            onSelected: _ctx.goToPaper,
            onSearched: _ctx.goToSearch
          }, null, 8, ["onSelected", "onSearched"])
        ]),
        (_ctx.user.enabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (!_ctx.user.isSignedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/login",
                    class: "inline-flex items-center ml-4 px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.user.isSignedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/register",
                    class: "ml-4 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.user.isSignedIn)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
                    class: "ml-4 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out"
                  }, " Log Out "))
                : _createCommentVNode("", true),
              (_ctx.user.isSignedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    to: "/user",
                    class: "ml-4 inline-flex items-center px-1 pt-1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.user.initial), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMobileMenu())),
            class: "inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out",
            "aria-label": "Main menu",
            "aria-expanded": "false"
          }, [
            (!_ctx.mobileMenuExpanded)
              ? (_openBlock(), _createBlock(_component_MenuIcon, {
                  key: 0,
                  class: "h-6 w-6"
                }))
              : _createCommentVNode("", true),
            (_ctx.mobileMenuExpanded)
              ? (_openBlock(), _createBlock(_component_XIcon, {
                  key: 1,
                  class: "h-6 w-6"
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      id: "mobileMenu",
      class: _normalizeClass(["lg:hidden", {
      hidden: !_ctx.mobileMenuExpanded,
      block: _ctx.mobileMenuExpanded
    }])
    }, [
      _createElementVNode("div", _hoisted_16, [
        (!_ctx.user.isSignedIn && _ctx.user.enabled)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/register",
              class: "mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.user.isSignedIn && _ctx.user.enabled)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/login",
              class: "mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.user.isSignedIn && _ctx.user.enabled)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: "/user",
              class: "mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.user.isSignedIn && _ctx.user.enabled)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: "/logout",
              class: "mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: "/c",
          class: "mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _hoisted_22,
        _hoisted_23
      ])
    ], 2)
  ]))
}